import AddSchoolsPricing from './AddSchoolsPricing.component';

export default AddSchoolsPricing;